import { f as u } from "../../fuzzysort-eoXOpoo6.js";
const o = (r, e) => {
  const t = u.single(r, e);
  if (!t)
    return;
  const n = t.indexes;
  return n[0] !== 0 ? [0, e.length] : [
    Math.max(...n.map((s) => s.valueOf())) + 1,
    e.length
  ];
};
export {
  o as getQueryRangeExclusive
};
